export default __webpack_public_path__ + "static/media/ic_tuvalu.9840c289.svg";